import {usePermissionsQuery} from '@hproduce/permissions'
import React from 'react'

import {Shell} from '../../shared/components/Shell'
import {useGetLinks} from '../../shared/routes/navLinks'
import {Context} from '../types/context.types'

type Props = {
  context: Context
  children: React.ReactNode
}

export const DefaultShell = ({context, children}: Props) => {
  const {data: permissions = []} = usePermissionsQuery()
  const navItems = useGetLinks({permissions})

  return (
    <Shell context={context} enableNotifications navItems={navItems}>
      {children}
    </Shell>
  )
}
